export default {
  views: {
    product: {
      plans: {
        title: '플랜 선택'
      },
      cancelPolicy: {
        title: '취소 정책'
      },
      recommendations: {
        title: '기타 추천'
      },
      panels: {
        selectDate: '날짜 선택',
        selectPlan: '플랜 선택',
        selectPeople: '인원 선택',
        options: '옵션',
        profile: '프로필'
      },
      auth: {
        loginOrRegister: '로그인 / 회원가입'
      }
    },
    book: {
      title: '예약 확인',
      bookingNotice: '예약 전 확인',
      paymentConfirmation: '결제 전 확인',
      tip: '주문을 확정하려면 15분 이내에 절차를 완료해 주세요.',
      sessionInfo: '예약 정보'
    },
    bookConfirm: {
      productInfo: '상품 정보',
      sessionConfirmed: '확인됨',
      sessionUnconfirmed: '미확인',
      paymentInfo: '결제 정보',
      paymentConfirmation: {
        warningTitle: '취소 정책을 확인하세요:',
        warningText: '구매 후 반환할 수 없습니다.',
        agreementText: '위의 내용을 확인하였고, 동의합니다.'
      },
      prePaymentConfirmation: {
        title: '결제 전 확인 사항',
        checkInput: '입력 내용이 올바른지 확인해 주세요.',
        emailNotice:
          '주의: 스팸 메일 차단을 위해 도메인 지정 수신 설정을 하신 경우, 예약 전 "@linktivity.co.jp" 도메인을 등록해 주세요.',
        agreementText: '위 사항을 확인하고 동의합니다.'
      },
      paymentAmount: {
        total: '결제 금액 (세금 포함)',
        details: '상세',
        note: '일본 엔화 이외의 통화로 표시되는 금액은 현재 환율을 기준으로 한 추정값이며, 실제 청구 금액과 다를 수 있습니다. 참고용으로 확인해 주시기 바랍니다.'
      },
      confirmPaymentDialogTitle: '결제 확인',
      participantInfo: {
        title: '참가자 정보',
        dialogTitle: '참가자 정보 변경',
        change: '변경',
        password: '비밀번호',
        validation: {
          passwordRequired: '비밀번호를 입력해 주세요'
        }
      },
      couponApplied: '쿠폰이 성공적으로 적용되었습니다',
      couponFailed: '쿠폰 적용에 실패했습니다',
      couponRemoved: '쿠폰이 성공적으로 제거되었습니다',
      couponRemoveFailed: '쿠폰 제거에 실패했습니다',
      actionButtons: {
        back: '이전',
        toPayment: '결제로'
      }
    },
    voucher: {
      pdf: '출력용 PDF',
      html: '바우처'
    },
    bookingDetail: {
      title: '예약 상세',
      detailInfo: '예약 상세',
      startDate: '참가 일시',
      validityPeriod: '유효 기간',
      voucherInfo: '바우처',
      digitalTicket: '전자 티켓',
      invoice: '영수증·송장',
      invoiceSend: '발행',
      invoiceSent: '송장 발행 완료',
      redemption: 'E-티켓 사용',
      meetingPoint: '입장 위치 안내',
      beforeTrip: '이용 전 확인 사항',
      bookingAction: '예약 관리',
      cancelBooking: '예약 취소',
      cancelConfirmPolicy: '취소 정책을 확인해 주세요:',
      customerName: '예약자명',
      actualPayment: '결제 금액',
      refundAmount: '환불 금액',
      orderId: '예약 ID',
      orderCompletionTime: '예약 시간',
      digitalTicketValidPeriod: 'QR 코드는 이용 당일에만 유효합니다',
      digitalTicketWaiting: '*주문 확인 후 전자 티켓이 여기에 표시됩니다',
      sending: '전송 중...',
      sendToEmail: '이메일로 전송',
      cancelConfirm: '예약을 취소하시겠습니까?',
      cancelFee: '취소 수수료',
      cancelRemarkSelect: '취소 사유를 선택해 주세요',
      inclusion: '포함된 물품',
      checklist: '주의사항',
      restrictions: '참가 제한',
      requirements: '참가 전 및 참가 중 필요 사항',
      attireItems: '참가 시 필요 의복 및 소지품',
      otherInfo: '비고·기타',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: 'Image'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: '기타',
      CANCEL_REASON_MODIFY_BOOKING: '예약 내용을 변경하고 싶어요',
      CANCEL_REASON_BOOKED_BY_MISTAKE: '잘못 예약함',
      CANCEL_REASON_DUPLICATE_BOOKING: '중복 예약이라서',
      CANCEL_REASON_HEALTH_CONDITION: '질병',
      CANCEL_REASON_TRANSPORTATION_ISSUE: '항공편 취소·지연·변경',
      CANCEL_REASON_SCHEDULE_CONFLICT: '일정 충돌',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: '다른 상품으로 변경'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    home: {
      title: 'Triplabo',
      header: {
        alt: 'Triplabo'
      },
      search: {
        placeholder: '상품 검색'
      },
      ticketList: {
        title: '티켓 목록'
      },
      enjoyPack: {
        title: '엔조이 팩'
      }
    }
  }
};
